import { render, staticRenderFns } from "./TableOrdenes.vue?vue&type=template&id=df45b85e"
import script from "./TableOrdenes.vue?vue&type=script&lang=js"
export * from "./TableOrdenes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports